export default __webpack_public_path__ + "static/media/vr.bbce191d.webp";